// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0.5.10/static/js/" + chunkId + "." + {"109":"97e5a2d2","694":"cc27cca8"}[chunkId] + ".chunk.js";
};